import React, { useState, useEffect } from "react";
import style from "./style.module.scss";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import useCommonStore from "../../../../../../stores/common";
import useMerchantStore from "../../../../../../stores/merchant";
import { getMerchantBatchCardSummary } from "../../../../../../../api";
import MonthPicker from "../../../../../../components/MonthPicker/Index";
import { getFullMonthName } from "../../../../../../../components/helper/helper";
import CardSummaryTable from "./table";

function CardSummary() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const [cardSummaryData, setCardSummaryData] = useState([]);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [loading, setLoading] = useState(false);

  const dateRange = useCommonStore((state) => state.dateRange);

  const fetchData = async () => {
    setLoading(true);
    const response = await getMerchantBatchCardSummary({
      powerapp_id: activeApp?.id,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    });
    if (response?.status) {
      setCardSummaryData(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [activeApp?.id, dateRange]);

  const onChangeFilter = (data) => {
    setYear(data.year);
    setMonth(getFullMonthName(data.month));
  };

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Card Summary</h5>
            </div>
            <div className={style.right}>
              {/* <MonthPicker
                text={<Filter />}
                submitText="Apply"
                onSubmit={(data) => onChangeFilter(data)}
              />
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon> */}
            </div>
          </header>

          <div className={style.body}>
            <CardSummaryTable data={cardSummaryData} loading={loading} />
          </div>
        </div>
      )}
    </>
  );
}

export default CardSummary;
